export const version = "15.0.4";
//# sourceMappingURL=version.js.map